export enum Lang {
  EN = 'en',
  ES = 'es',
  FR = 'fr',
  PT = 'pt',
}

export const availableLangs = [Lang.EN, Lang.ES, Lang.FR, Lang.PT];
